import CloseIcon from '@mui/icons-material/Close';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import NoInternet from 'components/Icons/NoInternet';
import type { FC } from 'react';
import React from 'react';

interface NoInternetModalProps {
  open: boolean;
  onClose: () => void;
}

const NoInternetModal: FC<NoInternetModalProps> = ({ open, onClose }) => {
  const theme: any = useTheme();
  const underSm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog open={open} onClose={onClose}>
      <div className={underSm ? 'h-[200px] w-full overflow-hidden' : ''}>
        <NoInternet />
      </div>
      <div className="my-1 text-center">
        <Typography className="mb-2">
          Please check your internet connection and try again.
        </Typography>
        <div className="m-auto mt-1 flex items-center justify-center text-center">
          <Button
            onClick={onClose}
            variant="contained"
            color="primary"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '15px',
              backgroundColor: '#FF605C',
              padding: '5px 15px',
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '14px',
              boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
            }}
          >
            Close
            <CloseIcon style={{ marginLeft: '5px' }} fontSize="small" />
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default NoInternetModal;
